import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { authAtom, userAtom, roleAtom, authStsAtom, subAtom } from '../../config/atoms';

import { ReceiptText, ChefHat, Inbox, SquareUser, FileText, Settings, LogOut, BedSingle, PackageCheck } from 'lucide-react';

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import icLogo from '../../../assets/image/logo-icon.png';

export default function NavigationBar() {

    const { page } = useParams();

    const [authStatus, setAuthStatus] = useRecoilState(authAtom);
    const [role, setUserRole] = useRecoilState(roleAtom);
    const [, setUserData] = useRecoilState(userAtom);
    const [, setAuthSts] = useRecoilState(authStsAtom);

    const [sub] = useRecoilState(subAtom);

    const navigate = useNavigate();

    const changeMainMenu = (link) => {
        if (sub.apps.includes("APP00002") && link === "reports") {
            navigate(`/reportHBook`);
        } else {
            navigate(`/${link}`);
        }
    }

    const logout = () => {
        setAuthStatus(false);
        setAuthSts('open');
        setUserData({});
        setUserRole({});
        localStorage.clear();
        sessionStorage.clear();
        navigate('/');
    }

    const getOrders = () => {
        if (page === 'order' || page === 'invoices' || page === 'booking') {
            return true;
        }
        return false;
    }

    const getInventory = () => {
        if (page === 'inventory' || page === 'invAdj' || page === 'invAdjAdd' || page === 'invItems' || page === 'itemAdd' || page === 'bom' || page === 'bomAdd') {
            return true;
        }
        return false;
    }

    const getStaff = () => {
        if (page === 'staff' || page === 'staffAdd') {
            return true;
        }
        return false;
    }

    const getSettings = () => {
        if (page === 'setting' || page === 'company' || page === 'subscription' || page === 'print' || page === 'tax' || page === 'table' || page === 'room' || page === 'roomType' || page === 'menu' || page === 'hostel') {
            return true;
        }
        return false;
    }

    const getReports = () => {
        if (page === 'reports' || page === 'bookReports' || page === 'reportItem' || page === 'reportOrder' || page === 'reportInvoice' || page === 'reportBooking' || page === 'reportHBook' || page === 'reportAttend' || page === 'reportGST' || page === 'reportCRM' || page === 'reportTrn') {
            return true;
        }
        return false;
    }

    const gotoReports = () => {
        if (sub.apps.includes("APP00002")) {
            navigate(`/reportHBook`);
        } else if (sub.features.isRoom) {
            navigate(`/bookReports`);
        } else {
            navigate(`/reports`);
        }
    }

    return (
        <>
            {!authStatus && <Navigate to="/" />}
            <div className="h-screen shadow-md bg-prime hidden xs:block w-16">
                <span className="cursor-pointer bg-gray-900 my-1" onClick={() => { changeMainMenu('pos') }}>
                    <div className="w-16 h-16 bg-gray-900">
                        <img src={icLogo} className="w-12 m-auto py-2" />
                    </div>
                </span>
                <div className='w-3/5 h-[2px] bg-white rounded-full mx-[20%]'></div>
                <ul className="flex flex-col items-center h-[90%]">
                    {
                        role.modules.includes("TERMINAL") && <Tippy content="POS Section" placement='right'>
                            <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${page === "pos" ? "bg-white text-ascent" : "text-white"}`} onClick={() => { changeMainMenu('pos') }}>
                                <ReceiptText size={20} />
                            </li>
                        </Tippy>
                    }
                    {
                        (sub.features.isRoom && role.modules.includes("BOOKING")) && <Tippy content="Rooms Section" placement='right'>
                            <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${page === "reception" ? "bg-white text-ascent" : "text-white"}`} onClick={() => { changeMainMenu('reception') }}>
                                <BedSingle size={20} />
                            </li>
                        </Tippy>
                    }
                    {
                        (sub.features.isKds && role.modules.includes("KDS")) && <Tippy content="KDS Section" placement='right'>
                            <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${page === "kds" ? "bg-white text-ascent" : "text-white"}`} onClick={() => { changeMainMenu('kds') }}>
                                <ChefHat size={20} />
                            </li>
                        </Tippy>
                    }
                    {
                        (role.modules.includes("ORDERS") && role.modules.includes("INVOICES")) && <Tippy content="Orders Section" placement='right'>
                            <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${getOrders() ? "bg-white text-ascent" : "text-white"}`} onClick={() => { changeMainMenu('invoices') }}>
                                <Inbox size={20} />
                            </li>
                        </Tippy>
                    }
                    {
                        (sub.features.isInv && role.modules.includes("INVENTORY")) && <Tippy content="Inventory Section" placement='right'>
                            <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${getInventory() ? "bg-white text-ascent" : "text-white"}`} onClick={() => { changeMainMenu('inventory') }}>
                                <PackageCheck size={20} />
                            </li>
                        </Tippy>
                    }
                    {
                        role.modules.includes("PROFILE") && <Tippy content="Staff Section" placement='right'>
                            <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${getStaff() ? "bg-white text-ascent" : "text-white"}`} onClick={() => { changeMainMenu('staff') }}>
                                <SquareUser size={20} />
                            </li>
                        </Tippy>
                    }
                    {
                        role.modules.includes("REPORTS") && < Tippy content="Reports Section" placement='right'>
                            <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${getReports() ? "bg-white text-ascent" : "text-white"}`} onClick={() => { gotoReports() }}>
                                <FileText size={20} />
                            </li>
                        </Tippy>
                    }
                    <div className='flex-grow'></div>
                    <Tippy content="Settings" placement='right'>
                        <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${getSettings() ? "bg-white text-ascent" : "text-white"}`} onClick={() => { changeMainMenu('setting') }}>
                            <Settings size={20} />
                        </li>
                    </Tippy>
                    <Tippy content="Logout" placement='right'>
                        <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white text-white hover:text-ascent`} onClick={() => { logout() }}>
                            <LogOut size={20} />
                        </li>
                    </Tippy>
                </ul>
                <p className='text-sm text-center text-white'>v2.0.0a</p>
            </div >
            <div className="fixed bottom-0 bg-white h-12 w-full rounded-t-md px-2 xs:hidden"></div>
        </>
    )
}
